export const arrowRightIcon = require("../assets/arrow_right.png");
export const footer = require("../assets/footer.png")
export const logo = require("../assets/logo.png")
export const jannaFont = require("../assets/ArbFONTS-Janna-LT-Regular (1).ttf")